define.alias("shared/components/shared/wizards/device-setup/step-one", "preview-grid/components/shared/wizards/device-setup/step-one");